import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./AvaliacoesAluno.module.css";
import Alerta from "../../components/alerta/Alerta";
import BotaoPaginaNovo from "../../components/botaoPaginaNovo/BotaoPaginaNovo";
import AvaliacaoApi from "../../services/AvaliacaoApi";
import { IoEyeSharp } from "react-icons/io5";
import Loader from "../../components/loader/Loader";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";
import { MdDelete, MdEdit } from "react-icons/md";
import { Button, Modal, Badge } from "react-bootstrap";
import AlunoApi from "../../services/AlunoApi";

function AvaliacoesAluno() {
  const location = useLocation();
  const isMobile = useIsMobile();

  const [alunoId, setAlunoId] = useState(null);
  const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [tipoAlerta, setTipoAlerta] = useState("");
  const [loading, setLoading] = useState(false);
  const [avaliacaoSelecionada, setAvaliacaoSelecionada] = useState(null);
  const [avaliacoes, setAvaliacoes] = useState([]);
  const [tipoAvaliacao, setTipoAvaliacao] = useState([]);
  const [mostrarModalDeletar, setMostrarModalDeletar] = useState(false);
  const [nomeAluno, setNomeAluno] = useState('');


  // Atualiza responsividade do menu
  useEffect(() => {
    setMenuHamburguerAberto(!isMobile);
  }, [isMobile]);

  // Inicializa alunoId com prioridade: location.state > localStorage
  useEffect(() => {
    const stateId = location.state;
    const storageId = localStorage.getItem("alunoId");

    if (stateId) {
      setAlunoId(stateId);
      localStorage.setItem("alunoId", stateId);
    } else if (storageId) {
      setAlunoId(storageId);
    }
  }, [location.state]);

  // Busca os dados assim que alunoId estiver disponível
  useEffect(() => {
    if (alunoId) {
      ListarAvaliacoesPorAluno();
      ListarTipoAvaliacaoEnum();
      buscarNomeAluno();
    }
  }, [alunoId]);

  // Limpa o localStorage ao desmontar (opcional)
  useEffect(() => {
    return () => {
      localStorage.removeItem("alunoId");
    };
  }, []);
  

  const exibirAlerta = () => {
    setMostrarAlerta(true);
    setTimeout(() => setMostrarAlerta(false), 5000);
  };

  async function ListarAvaliacoesPorAluno() {
 
    try {
      const lista = await AvaliacaoApi.ListarAvaliacaoPorAluno(alunoId);
      setAvaliacoes(lista);
    } catch {
      console.error("Erro ao buscar avaliações");
    } finally {
    
    }
  }

  async function ListarTipoAvaliacaoEnum() {
    try {
      const enums = await AvaliacaoApi.ListarEnumTipoAvaliacao();
      setTipoAvaliacao(enums);
    } catch {
      console.error("Erro ao buscar tipos de avaliação");
    }
  }

  function obterNomeTipoAvaliacao(tipo) {
    const encontrado = tipoAvaliacao.find(t => t.id === tipo || t.nome === tipo);
    return encontrado ? encontrado.nome : null;
  }

  async function DeletarAvaliacao() {
    try {
      await AvaliacaoApi.DeletarAvaliacao(avaliacaoSelecionada.id);
      setMensagemAlerta("Avaliação deletada com sucesso!");
      setTipoAlerta("success");
      exibirAlerta();
      FecharModal();
      ListarAvaliacoesPorAluno();
    } catch (error) {
      console.error("Erro ao deletar avaliação", error);
      setMensagemAlerta("Erro ao deletar a avaliação.");
      setTipoAlerta("danger");
      exibirAlerta();
    }
  }

  const AbrirModalDeletar = (avaliacao) => {
    setAvaliacaoSelecionada(avaliacao);
    setMostrarModalDeletar(true);
  };

  const FecharModal = () => {
    setMostrarModalDeletar(false);
    setAvaliacaoSelecionada(null);
  };

  async function buscarNomeAluno() {
    try {
      const aluno = await AlunoApi.ObterAlunoPorPessoaId(alunoId);
      setNomeAluno(aluno.nomeCompleto);
    } catch {
      console.error("Erro ao buscar nome do aluno");
    }
  }

  return (
    <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
      <Topbar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
        <Alerta
          tipo={tipoAlerta}
          mensagem={mensagemAlerta}
          visivel={mostrarAlerta}
          aoFechar={() => setMostrarAlerta(false)}
        />
        {loading && <Loader />}

        <div className={style.pagina_conteudo}>
          <div className={style.container_cabecalho}>
            
              <h4>
                Avaliações - <span className={style.nomeMenor}>{nomeAluno}</span>
              </h4>
            <BotaoPaginaNovo link={"/avaliacao/novo"} state={alunoId} />
          </div>

          <div className={style.container_tabela_paginacao}>
            <div className={style.tabela_responsiva}>
              <table className={style.container_tabela}>
                <thead>
                  <tr>
                    <th>Data Realizada</th>
                    <th>Status Avaliação</th>
                    <th className={style.coluna_acoes}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {avaliacoes.map((avaliacao) => (
                    <tr className={style.tabela_corpo} key={avaliacao.id}>
                      <td title={new Date(avaliacao.dataRealizada).toLocaleString("pt-BR")}>
                        {new Date(avaliacao.dataRealizada).toLocaleDateString("pt-BR")}
                      </td>
                      <td>
                        <Badge bg={avaliacao.tipoAvaliacaoEnum === 1 ? "success" : "danger"}>
                          {obterNomeTipoAvaliacao(avaliacao.tipoAvaliacaoEnum)}
                        </Badge>
                      </td>
                      <td className={style.coluna_acoes}>
                          <Link to="/avaliacao/AvaliacaoEditavel" state={avaliacao.id} className={style.botao_editar}>
                            <MdEdit title="Editar" />
                          </Link>
                        <Link to="/avaliacao/aluno" state={avaliacao.id} className={style.botao_visualizar}>
                          <IoEyeSharp title="Visualizar" />
                        </Link>
                        <Link onClick={() => AbrirModalDeletar(avaliacao)} className={style.botao_deletar}>
                          <MdDelete title="Deletar" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <Modal show={mostrarModalDeletar} onHide={FecharModal}>
                <Modal.Header closeButton>
                  <Modal.Title>Confirmar</Modal.Title>
                </Modal.Header>
                <Modal.Body>Tem certeza que deseja deletar a Avaliação?</Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={FecharModal}>Cancelar</Button>
                  <Button variant="danger" onClick={DeletarAvaliacao}>Deletar</Button>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </div>
      </Topbar>
    </Sidebar>
  );
}

export default AvaliacoesAluno;
